<div class="empty-state">
  <span class="empty-icon"><ng-icon [svg]="icon"></ng-icon></span>
  <h2>{{ title }}</h2>
  @if (text) {
    <p>{{ text }}</p>
  }
  <div class="empty-actions">
    <ng-content></ng-content>
  </div>
</div>
